import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Link from 'components/Link';
import Picture from 'components/Picture';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import { author as authorPropType } from 'lib/CustomPropTypes';
import { getTeaseByline } from 'lib/teaseUtils';
import get from 'lodash.get';

import recipeStyles from './styles.module.scss';
import todayStyles from '../styles.module.scss';


function Recipe(props) {
  const recipe = get(props, ['content', 'recipe'], null);
  if (!recipe) {
    return null;
  }
  const {
    headline,
    teaseImage,
    authors,
    url,
  } = recipe;

  const teaseImageUrl = teaseImage && teaseImage.url;

  const ctaWithoutTeaseImage = !teaseImageUrl ? (
    <div
      className={classNames(
        todayStyles.cta,
        todayStyles.ctaNoTeaseImage,
        recipeStyles.cta,
      )}
    >
      <Link to={url.primary}>
        { i18next.t('Get The Recipe') }
      </Link>
    </div>
  ) : null;

  const ctaWithTeaseImage = teaseImageUrl ? (
    <div className={todayStyles.imageWrapper}>
      <Picture
        url={teaseImageUrl.primary}
        responsiveFlavors={{
          s: AIMS_FLAVORS.FOCAL_600x300,
          m: AIMS_FLAVORS.FOCAL_720x360,
          l: AIMS_FLAVORS.FOCAL_920x460,
          xl: AIMS_FLAVORS.FOCAL_860x430,
        }}
        className={todayStyles.coverImage}
        alt={headline.primary}
      />
      <div className={todayStyles.byline}>
        {getTeaseByline(teaseImage)}
      </div>
      <div className={classNames(todayStyles.cta, recipeStyles.cta)}>
        <Link to={url.primary}>
          { i18next.t('Get The Recipe') }
        </Link>
      </div>
    </div>
  ) : null;

  return (
    <div className={todayStyles.todayCard}>
      {ctaWithTeaseImage}
      <div className={todayStyles.summaryContainer}>
        {ctaWithoutTeaseImage}
        <div className={todayStyles.titleContainer}>
          <h3 className={todayStyles.title}>
            <Link to={url.primary}>
              {headline.primary}
            </Link>
          </h3>
          <span className={recipeStyles.author}>
            {authors && authors[0] && authors[0].name}
          </span>
        </div>
        <div className={todayStyles.accentBorder} />
      </div>
    </div>
  );
}

Recipe.propTypes = {
  content: PropTypes.shape({
    recipe: PropTypes.shape({
      headline: PropTypes.shape({
        primary: PropTypes.string,
      }),
      authors: PropTypes.arrayOf(authorPropType),
      teaseImage: PropTypes.shape({
        url: PropTypes.shape({
          primary: PropTypes.string,
        }),
      }),
      url: PropTypes.shape({
        primary: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default Recipe;
